<script>
import Swal from "sweetalert2";
import axios from "axios";
import _ from "lodash";
import Pagination from "@/router/layouts/table-pagination.vue";
import Datatable from "@/router/layouts/table-datatable.vue";
import ModalFormDetailPeserta from "./modal-form-detail-peserta.vue";
import ModalImportDetailPeserta from "./modal-import-detail-peserta.vue";
import ModalDetailKompetensi from "./modal-detail-kompetensi.vue";
import ModalApprovePeserta from "./modal-approve-peserta.vue";

export default {
	props: {
    idWorkOrder: {
      type: [String, Number],
      required: true
    }
  },

	components: {
    Pagination,
    Datatable,
    ModalFormDetailPeserta,
    ModalImportDetailPeserta,
    ModalDetailKompetensi,
    ModalApprovePeserta,
	},

  data() {
    let sortOrders = []; // select sortOrder
    // definisi kolom yang dipakai
    let columns = [
      { width: "50px", label: "No", name: "-" },
      { width: "120px", label: "Kode", name: "-" },
      { width: "150px", label: "NIP", name: "nip" },
      { width: "450px", label: "Pegawai Internal", name: "pegawai_internal" },
      { width: "220px", label: "Nama Profesi", name: "nama_profesi" },
      { width: "200px", label: "Jenjang Jabatan", name: "jenjang_jabatan" },
      { width: "180px", label: "Target PeG", name: "target_peg" },
      { width: "220px", label: "Target Kompetensi", name: "target_kompetensi" },
      { width: "200px", label: "Level Kompetensi", name: "level_kompetensi" },
      { width: "180px", label: "Status", name: "-" },
      { width: "220px", label: "Aksi", name: "-" },
    ];
    // cek sorting
    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });

    return {
      tableData: {
        columns: columns,
        sortKey: "id_work_order_detail",
        sortOrders: sortOrders,
        loading: true,
        data: [],
        filter: {
          draw: 0,
          page: 1,
          per_page: 10,
          search: "",
          column: "id_work_order_detail",
          dir: "asc",
          nip: "",
          id_profesi: "",
          id_jenjang_jabatan: "",
          id_target_kompetensi: "",
          idlevel_kompetensi: "",
          status: "",
        },
        pagination: {
          lastPage: "",
          currentPage: "",
          total: "",
          lastPageUrl: "",
          nextPageUrl: "",
          prevPageUrl: "",
          from: "",
          to: "",
          links: "",
        },
      },

      modalConfiguration: {
        detailPeserta: false,
        importPeserta: false,
        detailKompetensi: false,
        approvePeserta: false,
      },

      // variable form detail peserta
      selectedDataFormDetailPeserta: null,
      formModeDetailPeserta: "add",

      // variable modal detail kompetensi
      selectedIdPegawaiInternal: null,
      selectedInfoPeserta: {},

      // variable filter
      selectedProfesi: null,
      optionProfesi: [],
      selectedJenjangJabatan: null,
      selectedTargetKompetensi: null,
      selectedLevelKompetensi: null,
      selectedStatus: null,
      optionJenjangJabatan: [],
      optionTargetKompetensi: [],
      optionLevelKompetensi: [],
      optionStatus: [
        { value: 0, text: "BELUM MEMILIH" },
        { value: 1, text: "PENDING" },
        { value: 2, text: "DIAJUKAN" },
        { value: 3, text: "DISETUJUI" },
      ],
    };
  },

  watch: {
    selectedProfesi(val) {
      this.tableData.filter.id_profesi = val?.id_mprofesi ?? "";
      this.getDataTable();
    },
    selectedJenjangJabatan(val) {
      this.tableData.filter.id_jenjang_jabatan = val?.id_jenjang_jabatan ?? "";
      this.getDataTable();
    },
    selectedTargetKompetensi(val) {
      this.tableData.filter.id_target_kompetensi =
        val?.id_target_kompetensi ?? "";
      this.getDataTable();
    },
    selectedLevelKompetensi(val) {
      this.tableData.filter.idlevel_kompetensi = val?.idlevel_kompetensi ?? "";
      this.getDataTable();
    },
    selectedStatus(val) {
      this.tableData.filter.status = val?.value ?? "";
      this.getDataTable();
    },
  },

  created() {
    // debounce supaya request pencarian tidak dikirim setiap ketikan
    this.filterData = _.debounce(this.getDataTable.bind(this), 500);
  },

	async mounted() {
    this.getProfesi();
    this.getJenjangJabatan();
    this.getTargetKompetensi();
    this.getLevelKompetensi();
    await this.getDataTable();
  },

  methods: {
    getProfesi() {
      axios({
        method: "get",
        url: process.env.VUE_APP_BACKEND_URL_VERSION + "master/profesi",
        params: {
          per_page: 200,
          column: "nama_profesi",
          dir: "asc",
          filter_status: "ENABLE",
        },
        headers: { Authorization: `Bearer ${localStorage.access_token}` },
      })
        .then((res) => {
          this.optionProfesi = res.data?.data?.data ?? [];
        })
        .catch((err) => console.log(err));
    },
    getJenjangJabatan() {
      axios({
        method: "get",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "master-asesmen/jenjang-jabatan",
        params: { per_page: 200, column: "nama_jenjang", dir: "asc" },
        headers: { Authorization: `Bearer ${localStorage.access_token}` },
      })
        .then((res) => {
          this.optionJenjangJabatan = res.data?.data?.data ?? [];
        })
        .catch((err) => console.log(err));
    },
    getTargetKompetensi() {
      axios({
        method: "get",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "master-asesmen/target-kompetensi",
        params: { per_page: 200, column: "target_kompetensi", dir: "asc" },
        headers: { Authorization: `Bearer ${localStorage.access_token}` },
      })
        .then((res) => {
          this.optionTargetKompetensi = res.data?.data?.data ?? [];
        })
        .catch((err) => console.log(err));
    },
    getLevelKompetensi() {
      axios({
        method: "get",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION + "verifikasi/level-kompetensi",
        params: { per_page: 200, column: "nama_level", dir: "asc" },
        headers: { Authorization: `Bearer ${localStorage.access_token}` },
      })
        .then((res) => {
          this.optionLevelKompetensi = res.data?.data?.data ?? [];
        })
        .catch((err) => console.log(err));
    },
    getDataTable(resetPage = true) {
      this.tableData.filter.page = resetPage ? 1 : this.tableData.filter.page;
      let self = this;
      self.tableData.loading = true;
      self.tableData.filter.draw++;

      let payload = { ...this.tableData.filter };
      if (resetPage) {
        this.tableData.filter.page = 1;
      }

      var config = {
        method: "get",
        url: process.env.VUE_APP_BACKEND_URL_VERSION + "work-order/detail/" + this.idWorkOrder,
        params: payload,
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };

      axios(config)
        .then((response) => {
          let response_data = response.data;
          let response_data_fix = response_data.data;
          if (response_data.meta.code == 200) {
            self.tableData.data = response_data_fix.data;
            self.configPagination(response_data_fix);
            self.tableData.pagination.currentPage =
              response_data_fix.current_page;
            self.tableData.loading = false;
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response_data_fix.data.message,
            });
          }
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    configPagination(data) {
      this.tableData.pagination.lastPage = data.last_page;
      this.tableData.pagination.currentPage = data.current_page;
      this.tableData.pagination.total = data.total;
      this.tableData.pagination.lastPageUrl = data.last_page_url;
      this.tableData.pagination.nextPageUrl = data.next_page_url;
      this.tableData.pagination.prevPageUrl = data.prev_page_url;
      this.tableData.pagination.from = data.from;
      this.tableData.pagination.to = data.to;
      this.tableData.pagination.links = data.links;
    },
    sortBy(key) {
      let self = this;
      self.tableData.sortKey = key;
      self.tableData.sortOrders[key] = self.tableData.sortOrders[key] * -1;
      self.tableData.filter.column = key;
      self.tableData.filter.dir =
        self.tableData.sortOrders[key] === 1 ? "asc" : "desc";
      self.getDataTable();
    },
    toPage(url) {
      let link = new URLSearchParams(url.split("?")[1] || "");
      this.tableData.filter.page = link.get("page");
      this.getDataTable(false);
    },

    addDetailPeserta() {
      this.formModeDetailPeserta = "add";
      this.selectedDataFormDetailPeserta = null;
      this.modalConfiguration.detailPeserta = true;
    },

    importDetailPeserta() {
      this.modalConfiguration.importPeserta = true;
    },

    approveDetailPeserta() {
      this.modalConfiguration.approvePeserta = true;
    },

    exportDetailPeserta() {
      let filter = {
        search: this.tableData.filter.search,
        nip: this.tableData.filter.nip,
        id_profesi: this.tableData.filter.id_profesi,
        id_jenjang_jabatan: this.tableData.filter.id_jenjang_jabatan,
        id_target_kompetensi: this.tableData.filter.id_target_kompetensi,
        idlevel_kompetensi: this.tableData.filter.idlevel_kompetensi,
        status: this.tableData.filter.status,
      };
      let params = new URLSearchParams(filter).toString();
      window.open(
        process.env.VUE_APP_BACKEND_URL_VERSION +
          "export-excel/work-order-detail/" +
          this.idWorkOrder +
          "?" +
          params
      );
    },

    showDetailKompetensi(data) {
      this.selectedIdPegawaiInternal = data.idpegawai_internal;
      this.selectedInfoPeserta = {
        kodePegawaiInternal: data.pegawai_internal?.u_nip || "-",
        namaPegawai: data.pegawai_internal?.nama || "-",
        namaProfesi: data.mprofesi?.nama_profesi || "-",
        jenjangJabatan: data.jenjang_jabatan?.nama_jenjang || "-",
        targetPeg: data.target_peg?.target_peg || "-",
        targetKompetensi: data.target_kompetensi?.target_kompetensi || "-",
        levelKompetensi: data.level_kompetensi?.nama_level || "-",
      };
      this.modalConfiguration.detailKompetensi = true;
    },

    editDetailPeserta(data) {
      this.formModeDetailPeserta = "edit";
      this.selectedDataFormDetailPeserta = data;
      this.modalConfiguration.detailPeserta = true;
    },

    destroyDetailPeserta(data) {
      Swal.fire({
        icon: "warning",
        title: "Apakah anda yakin menghapus data ini secara permanen ?",
        text: "Data yang dihapus tidak dapat dipulihkan kembali.",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Ya",
        denyButtonText: "Tidak",
      }).then((result) => {
        if (!result.isConfirmed) return;

        axios({
          method: "delete",
          url:
            process.env.VUE_APP_BACKEND_URL_VERSION +
            "work-order/detail/" +
            data.id_work_order_detail,
          headers: {
            Authorization: "Bearer " + localStorage.access_token,
          },
        })
          .then(() => {
            Swal.fire({
              icon: "success",
              title: "Berhasil",
              text: "Data berhasil dihapus",
              timer: 1500,
              timerProgressBar: true,
              showConfirmButton: false,
            });
            this.getDataTable(false);
          })
          .catch((err) => {
            Swal.fire({
              icon: "error",
              title: "Gagal",
              text:
                err.response?.data?.data ||
                err.response?.data?.meta?.message ||
                "Terjadi kesalahan.",
            });
          });
      });
    },
  },
};
</script>

<template>
  <div class="card">
    <div class="card-body">
      <div class="mym-box">
        <div class="mym-box-left">
          <h4 class="fw-bold">List Data Peserta</h4>
        </div>
        <div class="mym-box-right">
          <b-button
            variant="info"
            size="sm"
            class="fw-bold btn-block"
            @click="exportDetailPeserta"
          >
            <i class="fa fa-file-excel me-1"></i>
            Export Excel
          </b-button>
          <b-button
            variant="warning"
            size="sm"
            class="fw-bold btn-block ms-2"
            @click="approveDetailPeserta"
          >
            <i class="fa fa-check-double me-1"></i>
            Approve Peserta
          </b-button>
          <b-button
            variant="success"
            size="sm"
            class="fw-bold btn-block ms-2"
            @click="importDetailPeserta"
          >
            <i class="fa fa-file-import me-1"></i>
            Import Data
          </b-button>
          <b-button
            variant="primary"
            size="sm"
            class="fw-bold btn-block ms-2"
            @click="addDetailPeserta"
          >
            <i class="fa fa-plus me-1"></i>
            Tambah
          </b-button>
        </div>
      </div>

      <hr />

      <div class="row mb-2">
        <div class="form-group col-md-3 mb-3">
          <label for="filterNip">NIP</label>
          <input
            id="filterNip"
            type="text"
            class="form-control"
            placeholder="Filter NIP"
            v-model="tableData.filter.nip"
            @input="filterData"
          />
        </div>
        <div class="form-group col-md-3 mb-3">
          <label for="filterProfesi">Nama Profesi</label>
          <v-select
            id="filterProfesi"
            :options="optionProfesi"
            label="nama_profesi"
            :get-option-key="(option) => option.id_mprofesi"
            v-model="selectedProfesi"
            placeholder="Semua"
          >
            <template #option="option">{{ option.nama_profesi }}</template>
            <template #selected-option="option">{{ option.nama_profesi }}</template>
          </v-select>
        </div>
        <div class="form-group col-md-3 mb-3">
          <label for="filterJenjangJabatan">Jenjang Jabatan</label>
          <v-select
            id="filterJenjangJabatan"
            :options="optionJenjangJabatan"
            label="nama_jenjang"
            :get-option-key="(option) => option.id_jenjang_jabatan"
            v-model="selectedJenjangJabatan"
            placeholder="Semua"
          >
            <template #option="option">{{ option.nama_jenjang }}</template>
            <template #selected-option="option">{{ option.nama_jenjang }}</template>
          </v-select>
        </div>
        <div class="form-group col-md-3 mb-3">
          <label for="filterTargetKompetensi">Target Kompetensi</label>
          <v-select
            id="filterTargetKompetensi"
            :options="optionTargetKompetensi"
            label="target_kompetensi"
            :get-option-key="(option) => option.id_target_kompetensi"
            v-model="selectedTargetKompetensi"
            placeholder="Semua"
          >
            <template #option="option">{{ option.target_kompetensi }}</template>
            <template #selected-option="option">{{ option.target_kompetensi }}</template>
          </v-select>
        </div>
        <div class="form-group col-md-3 mb-3">
          <label for="filterLevelKompetensi">Level Kompetensi</label>
          <v-select
            id="filterLevelKompetensi"
            :options="optionLevelKompetensi"
            label="nama_level"
            :get-option-key="(option) => option.idlevel_kompetensi"
            v-model="selectedLevelKompetensi"
            placeholder="Semua"
          >
            <template #option="option">{{ option.nama_level }}</template>
            <template #selected-option="option">{{ option.nama_level }}</template>
          </v-select>
        </div>
        <div class="form-group col-md-3 mb-3">
          <label for="filterStatus">Status</label>
          <v-select
            id="filterStatus"
            :options="optionStatus"
            label="text"
            :get-option-key="(option) => option.value"
            v-model="selectedStatus"
            placeholder="Semua"
          >
            <template #option="option">{{ option.text }}</template>
            <template #selected-option="option">{{ option.text }}</template>
          </v-select>
        </div>
      </div>

      <div class="row">
        <datatable
          :columns="tableData.columns"
          :sortKey="tableData.sortKey"
          :sortOrders="tableData.sortOrders"
          @sort="sortBy"
        >
          <tbody>
            <tr v-if="tableData.loading">
              <td colspan="99" class="text-center">
                <i class="fas fa-spinner fa-spin"></i> Loading...
              </td>
            </tr>
            <tr
              v-else-if="!tableData.data || tableData.data.length === 0"
              class="text-center"
            >
              <td class="text-center" colspan="99">Data Tidak Tersedia</td>
            </tr>
            <tr
              v-else
              v-for="(row_data, key_data) in tableData.data"
              :key="row_data.id_work_order_detail"
            >
              <td class="text-center">
                {{
                  (tableData.pagination.currentPage - 1) *
                    (tableData.filter.per_page || 10) +
                  key_data +
                  1
                }}
              </td>
              <td class="text-center">{{ row_data.work_order?.kode || "-" }}</td>
              <td class="text-center">
                {{ row_data.pegawai_internal?.u_nip || "-" }}
              </td>
              <td class="text-center">
                {{ row_data.pegawai_internal?.nama || "-" }}
              </td>
              <td class="text-center">
                {{ row_data.mprofesi?.nama_profesi || "-" }}
              </td>
              <td class="text-center">
                {{ row_data.jenjang_jabatan?.nama_jenjang || "-" }}
              </td>
              <td class="text-center">
                {{ row_data.target_peg?.target_peg || "-" }}
              </td>
              <td class="text-center">
                {{ row_data.target_kompetensi?.target_kompetensi || "-" }}
              </td>
              <td class="text-center">
                {{ row_data.level_kompetensi?.nama_level || "-" }}
              </td>
              <td class="text-center">
                <span v-if="row_data?.work_order_peserta?.status == 1" 
                  class="badge rounded-pill bg-gradient bg-warning py-2 px-4 fw-bold text-nowrap w-100"
                >
                  <i class="far fa-hourglass me-1"></i>
                  PENDING
                </span>
                <span v-else-if="row_data?.work_order_peserta?.status == 2" 
                  class="badge rounded-pill bg-gradient bg-info py-2 px-4 fw-bold text-nowrap w-100"
                >
                  <i class="fa fa-paper-plane me-1"></i>
                  DIAJUKAN
                </span>
                <span v-else-if="row_data?.work_order_peserta?.status == 3" 
                  class="badge rounded-pill bg-gradient bg-success py-2 px-4 fw-bold text-nowrap w-100"
                >
                  <i class="fa fa-check me-1"></i>
                  DISETUJUI
                </span>
                <span v-else 
                  class="badge rounded-pill bg-gradient bg-secondary py-2 px-4 fw-bold text-nowrap w-100"
                >
                  <i class="fas fa-stopwatch me-1"></i>
                  BELUM MEMILIH
                </span>
              </td>
              <td class="text-center">
                <div class="btn-group btn-group-sm">
                  <button
                    class="btn btn-info btn-sm text-nowrap fw-bold"
                    @click="showDetailKompetensi(row_data)"
                  >
                    <i class="fa fa-list me-1"></i> Kompetensi
                  </button>
                  <button
                    class="btn btn-primary btn-sm text-nowrap fw-bold"
                    @click="editDetailPeserta(row_data)"
                  >
                    <i class="fa fa-pencil-alt me-1"></i> Edit
                  </button>
                  <button
                    class="btn btn-danger btn-sm text-nowrap fw-bold"
                    @click="destroyDetailPeserta(row_data)"
                  >
                    <i class="fa fa-trash me-1"></i> Hapus
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </datatable>
      </div>
      <pagination
        :pagination="tableData.pagination"
        @to-page="toPage"
      ></pagination>

      <hr class="five-dashes" />

      <div class="mt-2 d-flex flex-column align-items-end">
        <table class="table table-borderless mb-0 w-auto align-middle">
          <thead>
            <tr>
              <th colspan="3" class="text-end fw-bold p-2">Keterangan Status <i class="fas fa-info-circle text-primary ms-1"></i></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="px-2 text-muted text-end">Peserta belum memilih kompetensi</td>
              <td class="px-2">:</td>
              <td class="px-2 py-1">
                <span class="badge rounded-pill bg-gradient bg-secondary py-2 px-3 fw-bold text-nowrap">
                  <i class="fas fa-stopwatch me-1"></i> BELUM MEMILIH
                </span>
              </td>
            </tr>
            <tr>
              <td class="px-2 text-muted text-end">Sudah memilih kompetensi tapi belum diajukan</td>
              <td class="px-2">:</td>
              <td class="px-2 py-1">
                <span class="badge rounded-pill bg-gradient bg-warning py-2 px-3 fw-bold text-nowrap">
                  <i class="far fa-hourglass me-1"></i> PENDING
                </span>
              </td>
            </tr>
            <tr>
              <td class="px-2 text-muted text-end">Sudah mengajukan pemilihan kompetensi</td>
              <td class="px-2">:</td>
              <td class="px-2 py-1">
                <span class="badge rounded-pill bg-gradient bg-info py-2 px-3 fw-bold text-nowrap">
                  <i class="fa fa-paper-plane me-1"></i> DIAJUKAN
                </span>
              </td>
            </tr>
            <tr>
              <td class="px-2 text-muted text-end">Sudah disetujui oleh atasan</td>
              <td class="px-2">:</td>
              <td class="px-2 py-1">
                <span class="badge rounded-pill bg-gradient bg-success py-2 px-3 fw-bold text-nowrap">
                  <i class="fa fa-check me-1"></i> DISETUJUI
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="row">
        <div class="col-12">
          <ModalFormDetailPeserta
            :show="modalConfiguration.detailPeserta"
            :data="selectedDataFormDetailPeserta"
            :mode="formModeDetailPeserta"
            :idWorkOrder="idWorkOrder"
            @close="modalConfiguration.detailPeserta = false"
            @finish="getDataTable()"
          />
          <ModalImportDetailPeserta
            :show="modalConfiguration.importPeserta"
            :idWorkOrder="idWorkOrder"
            @close="modalConfiguration.importPeserta = false"
            @finish="getDataTable()"
          />
          <ModalDetailKompetensi
            :show="modalConfiguration.detailKompetensi"
            :idPegawaiInternal="selectedIdPegawaiInternal"
            :infoPeserta="selectedInfoPeserta"
            @close="modalConfiguration.detailKompetensi = false"
          />
          <ModalApprovePeserta
            :show="modalConfiguration.approvePeserta"
            :idWorkOrder="idWorkOrder"
            @close="modalConfiguration.approvePeserta = false"
            @finish="getDataTable()"
          />
        </div>
      </div>
    </div>
  </div>
</template>